import {
  Companion_getInstance9bcftd4fcpen as Companion_getInstance,
  ServerFileWithMetadata2wurhrhm98oms as ServerFileWithMetadata,
} from './ServerFileWithMetadata.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { ServerFile1t91jzpzoixwe as ServerFile } from '../files/ServerFile.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareServerFileWithMetadataFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [ServerFileWithMetadata_original_getInstance(), ServerFileWithMetadata_mimeType_getInstance(), ServerFileWithMetadata_size_getInstance(), ServerFileWithMetadata_width_getInstance(), ServerFileWithMetadata_height_getInstance(), ServerFileWithMetadata_previews_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function ServerFileWithMetadata_original$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function ServerFileWithMetadata_original$_get_name_$ref_r3orw7() {
  return (p0) => p0.i20();
}
function ServerFileWithMetadata_original$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ServerFileWithMetadata_original$_get_serializer_$ref_75tz5c() {
  return (p0) => p0.h2j();
}
function ServerFileWithMetadata_original$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function ServerFileWithMetadata_original$_get_annotations_$ref_p1666k() {
  return (p0) => p0.bz();
}
var ServerFileWithMetadata_originalClass;
function ServerFileWithMetadata_original() {
  if (ServerFileWithMetadata_originalClass === VOID) {
    class $ {
      constructor() {
        ServerFileWithMetadata_original_instance = this;
        var tmp = this;
        tmp.u36_1 = lazy(ServerFileWithMetadata_original$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v36_1 = lazy(ServerFileWithMetadata_original$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w36_1 = lazy(ServerFileWithMetadata_original$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.u36_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ServerFileWithMetadata_original$_get_name_$ref_r3orw7(), null);
        return tmp0.f2();
      }
      x36(receiver) {
        return receiver.y36_1;
      }
      k2j(receiver) {
        return new (ServerFile())(this.x36(receiver instanceof ServerFileWithMetadata() ? receiver : THROW_CCE()));
      }
      e37(receiver, value) {
        return receiver.f37(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ServerFileWithMetadata() ? receiver : THROW_CCE();
        return this.e37(tmp, value instanceof ServerFile() ? value.l2n_1 : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.v36_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ServerFileWithMetadata_original$_get_serializer_$ref_75tz5c(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w36_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ServerFileWithMetadata_original$_get_annotations_$ref_p1666k(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ServerFileWithMetadata_original', VOID, VOID, [SerializableProperty()]);
    ServerFileWithMetadata_originalClass = $;
  }
  return ServerFileWithMetadata_originalClass;
}
var ServerFileWithMetadata_original_instance;
function ServerFileWithMetadata_original_getInstance() {
  if (ServerFileWithMetadata_original_instance === VOID)
    new (ServerFileWithMetadata_original())();
  return ServerFileWithMetadata_original_instance;
}
function ServerFileWithMetadata_mimeType$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function ServerFileWithMetadata_mimeType$_get_name_$ref_sv3spy() {
  return (p0) => p0.i20();
}
function ServerFileWithMetadata_mimeType$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ServerFileWithMetadata_mimeType$_get_serializer_$ref_p7lgwd() {
  return (p0) => p0.h2j();
}
function ServerFileWithMetadata_mimeType$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function ServerFileWithMetadata_mimeType$_get_annotations_$ref_gay0nj() {
  return (p0) => p0.bz();
}
var ServerFileWithMetadata_mimeTypeClass;
function ServerFileWithMetadata_mimeType() {
  if (ServerFileWithMetadata_mimeTypeClass === VOID) {
    class $ {
      constructor() {
        ServerFileWithMetadata_mimeType_instance = this;
        var tmp = this;
        tmp.g37_1 = lazy(ServerFileWithMetadata_mimeType$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h37_1 = lazy(ServerFileWithMetadata_mimeType$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.i37_1 = lazy(ServerFileWithMetadata_mimeType$annotations$delegate$lambda);
        this.j37_1 = null;
        this.k37_1 = 'null';
      }
      i20() {
        var tmp0 = this.g37_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ServerFileWithMetadata_mimeType$_get_name_$ref_sv3spy(), null);
        return tmp0.f2();
      }
      l37(receiver) {
        return receiver.z36_1;
      }
      k2j(receiver) {
        return this.l37(receiver instanceof ServerFileWithMetadata() ? receiver : THROW_CCE());
      }
      m37(receiver, value) {
        return receiver.f37(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ServerFileWithMetadata() ? receiver : THROW_CCE();
        return this.m37(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.h37_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ServerFileWithMetadata_mimeType$_get_serializer_$ref_p7lgwd(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i37_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ServerFileWithMetadata_mimeType$_get_annotations_$ref_gay0nj(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ServerFileWithMetadata_mimeType', VOID, VOID, [SerializableProperty()]);
    ServerFileWithMetadata_mimeTypeClass = $;
  }
  return ServerFileWithMetadata_mimeTypeClass;
}
var ServerFileWithMetadata_mimeType_instance;
function ServerFileWithMetadata_mimeType_getInstance() {
  if (ServerFileWithMetadata_mimeType_instance === VOID)
    new (ServerFileWithMetadata_mimeType())();
  return ServerFileWithMetadata_mimeType_instance;
}
function ServerFileWithMetadata_size$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(2);
}
function ServerFileWithMetadata_size$_get_name_$ref_i4k60p() {
  return (p0) => p0.i20();
}
function ServerFileWithMetadata_size$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ServerFileWithMetadata_size$_get_serializer_$ref_tqtcf4() {
  return (p0) => p0.h2j();
}
function ServerFileWithMetadata_size$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(2);
}
function ServerFileWithMetadata_size$_get_annotations_$ref_hew36k() {
  return (p0) => p0.bz();
}
var ServerFileWithMetadata_sizeClass;
function ServerFileWithMetadata_size() {
  if (ServerFileWithMetadata_sizeClass === VOID) {
    class $ {
      constructor() {
        ServerFileWithMetadata_size_instance = this;
        var tmp = this;
        tmp.n37_1 = lazy(ServerFileWithMetadata_size$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.o37_1 = lazy(ServerFileWithMetadata_size$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.p37_1 = lazy(ServerFileWithMetadata_size$annotations$delegate$lambda);
        this.q37_1 = null;
        this.r37_1 = 'null';
      }
      i20() {
        var tmp0 = this.n37_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ServerFileWithMetadata_size$_get_name_$ref_i4k60p(), null);
        return tmp0.f2();
      }
      l37(receiver) {
        return receiver.a37_1;
      }
      k2j(receiver) {
        return this.l37(receiver instanceof ServerFileWithMetadata() ? receiver : THROW_CCE());
      }
      s37(receiver, value) {
        return receiver.f37(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ServerFileWithMetadata() ? receiver : THROW_CCE();
        return this.s37(tmp, (value == null ? true : typeof value === 'bigint') ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.o37_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ServerFileWithMetadata_size$_get_serializer_$ref_tqtcf4(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.p37_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ServerFileWithMetadata_size$_get_annotations_$ref_hew36k(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ServerFileWithMetadata_size', VOID, VOID, [SerializableProperty()]);
    ServerFileWithMetadata_sizeClass = $;
  }
  return ServerFileWithMetadata_sizeClass;
}
var ServerFileWithMetadata_size_instance;
function ServerFileWithMetadata_size_getInstance() {
  if (ServerFileWithMetadata_size_instance === VOID)
    new (ServerFileWithMetadata_size())();
  return ServerFileWithMetadata_size_instance;
}
function ServerFileWithMetadata_width$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(3);
}
function ServerFileWithMetadata_width$_get_name_$ref_p8zd94() {
  return (p0) => p0.i20();
}
function ServerFileWithMetadata_width$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ServerFileWithMetadata_width$_get_serializer_$ref_6ezsh() {
  return (p0) => p0.h2j();
}
function ServerFileWithMetadata_width$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(3);
}
function ServerFileWithMetadata_width$_get_annotations_$ref_aks8zx() {
  return (p0) => p0.bz();
}
var ServerFileWithMetadata_widthClass;
function ServerFileWithMetadata_width() {
  if (ServerFileWithMetadata_widthClass === VOID) {
    class $ {
      constructor() {
        ServerFileWithMetadata_width_instance = this;
        var tmp = this;
        tmp.t37_1 = lazy(ServerFileWithMetadata_width$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u37_1 = lazy(ServerFileWithMetadata_width$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v37_1 = lazy(ServerFileWithMetadata_width$annotations$delegate$lambda);
        this.w37_1 = null;
        this.x37_1 = 'null';
      }
      i20() {
        var tmp0 = this.t37_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ServerFileWithMetadata_width$_get_name_$ref_p8zd94(), null);
        return tmp0.f2();
      }
      l37(receiver) {
        return receiver.b37_1;
      }
      k2j(receiver) {
        return this.l37(receiver instanceof ServerFileWithMetadata() ? receiver : THROW_CCE());
      }
      y37(receiver, value) {
        return receiver.f37(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ServerFileWithMetadata() ? receiver : THROW_CCE();
        return this.y37(tmp, (value == null ? true : typeof value === 'number') ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.u37_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ServerFileWithMetadata_width$_get_serializer_$ref_6ezsh(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v37_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ServerFileWithMetadata_width$_get_annotations_$ref_aks8zx(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ServerFileWithMetadata_width', VOID, VOID, [SerializableProperty()]);
    ServerFileWithMetadata_widthClass = $;
  }
  return ServerFileWithMetadata_widthClass;
}
var ServerFileWithMetadata_width_instance;
function ServerFileWithMetadata_width_getInstance() {
  if (ServerFileWithMetadata_width_instance === VOID)
    new (ServerFileWithMetadata_width())();
  return ServerFileWithMetadata_width_instance;
}
function ServerFileWithMetadata_height$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(4);
}
function ServerFileWithMetadata_height$_get_name_$ref_5zgg9t() {
  return (p0) => p0.i20();
}
function ServerFileWithMetadata_height$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ServerFileWithMetadata_height$_get_serializer_$ref_5urfy2() {
  return (p0) => p0.h2j();
}
function ServerFileWithMetadata_height$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(4);
}
function ServerFileWithMetadata_height$_get_annotations_$ref_nbpjuy() {
  return (p0) => p0.bz();
}
var ServerFileWithMetadata_heightClass;
function ServerFileWithMetadata_height() {
  if (ServerFileWithMetadata_heightClass === VOID) {
    class $ {
      constructor() {
        ServerFileWithMetadata_height_instance = this;
        var tmp = this;
        tmp.z37_1 = lazy(ServerFileWithMetadata_height$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a38_1 = lazy(ServerFileWithMetadata_height$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b38_1 = lazy(ServerFileWithMetadata_height$annotations$delegate$lambda);
        this.c38_1 = null;
        this.d38_1 = 'null';
      }
      i20() {
        var tmp0 = this.z37_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ServerFileWithMetadata_height$_get_name_$ref_5zgg9t(), null);
        return tmp0.f2();
      }
      l37(receiver) {
        return receiver.c37_1;
      }
      k2j(receiver) {
        return this.l37(receiver instanceof ServerFileWithMetadata() ? receiver : THROW_CCE());
      }
      y37(receiver, value) {
        return receiver.f37(VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ServerFileWithMetadata() ? receiver : THROW_CCE();
        return this.y37(tmp, (value == null ? true : typeof value === 'number') ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.a38_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ServerFileWithMetadata_height$_get_serializer_$ref_5urfy2(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b38_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ServerFileWithMetadata_height$_get_annotations_$ref_nbpjuy(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ServerFileWithMetadata_height', VOID, VOID, [SerializableProperty()]);
    ServerFileWithMetadata_heightClass = $;
  }
  return ServerFileWithMetadata_heightClass;
}
var ServerFileWithMetadata_height_instance;
function ServerFileWithMetadata_height_getInstance() {
  if (ServerFileWithMetadata_height_instance === VOID)
    new (ServerFileWithMetadata_height())();
  return ServerFileWithMetadata_height_instance;
}
function ServerFileWithMetadata_previews$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(5);
}
function ServerFileWithMetadata_previews$_get_name_$ref_grjti5() {
  return (p0) => p0.i20();
}
function ServerFileWithMetadata_previews$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ServerFileWithMetadata_previews$_get_serializer_$ref_x8ykhi() {
  return (p0) => p0.h2j();
}
function ServerFileWithMetadata_previews$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(5);
}
function ServerFileWithMetadata_previews$_get_annotations_$ref_k6hswe() {
  return (p0) => p0.bz();
}
var ServerFileWithMetadata_previewsClass;
function ServerFileWithMetadata_previews() {
  if (ServerFileWithMetadata_previewsClass === VOID) {
    class $ {
      constructor() {
        ServerFileWithMetadata_previews_instance = this;
        var tmp = this;
        tmp.e38_1 = lazy(ServerFileWithMetadata_previews$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.f38_1 = lazy(ServerFileWithMetadata_previews$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.g38_1 = lazy(ServerFileWithMetadata_previews$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'kotlin.collections.listOf' call
        tmp_2.h38_1 = emptyList();
        this.i38_1 = 'listOf()';
      }
      i20() {
        var tmp0 = this.e38_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ServerFileWithMetadata_previews$_get_name_$ref_grjti5(), null);
        return tmp0.f2();
      }
      l37(receiver) {
        return receiver.d37_1;
      }
      k2j(receiver) {
        return this.l37(receiver instanceof ServerFileWithMetadata() ? receiver : THROW_CCE());
      }
      j38(receiver, value) {
        return receiver.f37(VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ServerFileWithMetadata() ? receiver : THROW_CCE();
        return this.j38(tmp, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.f38_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ServerFileWithMetadata_previews$_get_serializer_$ref_x8ykhi(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.g38_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ServerFileWithMetadata_previews$_get_annotations_$ref_k6hswe(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ServerFileWithMetadata_previews', VOID, VOID, [SerializableProperty()]);
    ServerFileWithMetadata_previewsClass = $;
  }
  return ServerFileWithMetadata_previewsClass;
}
var ServerFileWithMetadata_previews_instance;
function ServerFileWithMetadata_previews_getInstance() {
  if (ServerFileWithMetadata_previews_instance === VOID)
    new (ServerFileWithMetadata_previews())();
  return ServerFileWithMetadata_previews_instance;
}
//region block: exports
export {
  prepareServerFileWithMetadataFields as prepareServerFileWithMetadataFields1v03v7klkn1h7,
};
//endregion

//# sourceMappingURL=ServerFileWithMetadataFields.mjs.map
